/**
 * Create media queries array based on the passed in breakpoints
 *
 * @param {Array} breakpoints The passed in breakpoints array
 *
 * @returns {Array} The generated media queries array
 */
var createMediaQueries = function createMediaQueries(breakpoints) {
  return breakpoints.map(function (n) {
    return "@media screen and (min-width:".concat(n, ")");
  });
};

export { createMediaQueries };